import React, { useState, useEffect, useCallback } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Row, Card, CardBody } from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { Colxx } from "../common/CustomBootstrap";
import { getSeatsAndSlotsRestaurant } from "../../redux/alacarte/actions";
import NameRoomAndMainCourseInfo from "./NameRoomAndMainCourseInfo";

const AlacarteServiceInfoSection = ({
  request, getSeatsAndSlots, settings, getSeatsAndSlotsRestaurant
}) => {
  const [alacarteRestaurantId, setAlacarteRestaurantId] = useState(false);
  const [alacarteRequestTimeSlot, setAlacarteRequestTimeSlot] = useState(false);
  const requestServiceType = request.service_type;

  const getSeatsAndSlotsOfAlacarteRestaurant = useCallback(async () => {
    const parsedReqCustomFiledValue = JSON.parse(
      request.custom_fields_values.find(cfv => cfv.id === "211" || cfv.id === 211)?.value
    );
    const restaurantId = parsedReqCustomFiledValue.restaurant_id;
    setAlacarteRestaurantId({ alacarteRestaurantId: restaurantId });

    if (!getSeatsAndSlots[`${restaurantId}`]) {
      const { hotelConfig } = settings;
      const payload = { hotel_id: hotelConfig.hotelId, restaurant_id: restaurantId };
      await getSeatsAndSlotsRestaurant(payload);
    }
  }, [request, settings, getSeatsAndSlots, getSeatsAndSlotsRestaurant, setAlacarteRestaurantId]);

  useEffect(() => {
    getSeatsAndSlotsOfAlacarteRestaurant();
  }, [getSeatsAndSlotsOfAlacarteRestaurant]);

  const getAlacarteRequestTimeSlot = useCallback(() => {
    const days = ['sundays', 'mondays', 'tuesdays', 'wednesdays', 'thursdays', 'fridays', 'saturdays'];
    const selectedDate = new Date(parseInt(request.due_at, 10) * 1000);
    const selectedDay = days[selectedDate.getDay()];
    const selectedHour = ("0" + selectedDate.getHours()).slice(-2);
    const selectedMinute = ("0" + selectedDate.getMinutes()).slice(-2);

    if (getSeatsAndSlots?.[`${alacarteRestaurantId}`]?.config?.time_slots) {
      const timeSlots = getSeatsAndSlots[`${alacarteRestaurantId}`].config.time_slots[`${selectedDay}`];
      timeSlots.forEach(timeSlot => {
        if (timeSlot.opens_at === `${selectedHour}:${selectedMinute}`) {
          setAlacarteRequestTimeSlot({
            alacarteRequestTimeSlot: `${timeSlot.opens_at} - ${timeSlot.closes_at}`
          });
        }
        if (timeSlot.all_day) {
          setAlacarteRequestTimeSlot({ alacarteRequestTimeSlot: "All-Day" });
        }
      });
    }
  }, [request, getSeatsAndSlots, alacarteRestaurantId, setAlacarteRequestTimeSlot]);

  useEffect(() => {
    if (alacarteRestaurantId && !alacarteRequestTimeSlot) {
      getAlacarteRequestTimeSlot();
    }
  }, [alacarteRestaurantId, alacarteRequestTimeSlot, getAlacarteRequestTimeSlot]);

  const getNameRoomAndMainCourses = () => {
    if (request.custom_fields_values) {
      if (request.custom_fields_values.some(cfv => cfv.id === "213" || cfv.id === 213)) {
        return JSON.parse(
          request.custom_fields_values.find(cfv => cfv.id === "213" || cfv.id === 213)?.value
        );
      }
    }
  }

  const getNameRoomAndMainCoursesAdult = () => {
    return getNameRoomAndMainCourses()?.filter(
      res => res.is_children === false || res.is_children === "false"
    );
  }

  const getNameRoomAndMainCoursesChild = () => {
    return getNameRoomAndMainCourses()?.filter(
      res => res.is_children === true || res.is_children === "true"
    );
  }

  // Burayı satırı hiçbir şekilde silme
  if (!request) return (<>Request Not Found</>);

  if (requestServiceType !== "ALACARTE_RESTAURANT_RESERVATION") return (<></>);

  return (
    <Card className="question d-flex mb-4">
      <div alt="Detail" className="card-img-top request_color closed">
        <h3 className="text-center align-middle w-100 mt-3 mb-3">
          <IntlMessages id="alacarte.request_person_info" />
        </h3>
      </div>

      <CardBody>
        {getNameRoomAndMainCourses()?.length > 0 ?
          (
            <Row>
              {getNameRoomAndMainCoursesAdult().map((res, index) => {
                return (
                  <Colxx xxs="12" lg="4" className="mb-1" key={index}>
                    <Card className="mb-1">
                      <CardBody>
                        <div>
                          <p className="text-center">
                            <IntlMessages id="alacarte.adult" /> - {index + 1}
                          </p>
                        </div>

                        <hr />

                        <NameRoomAndMainCourseInfo
                          res={res}
                          request={request}
                          alacarteRequestTimeSlot={alacarteRequestTimeSlot}
                        />
                      </CardBody>
                    </Card>
                  </Colxx>
                );
              })}

              {getNameRoomAndMainCoursesChild().map((res, index) => {
                return (
                  <Colxx xxs="12" lg="4" className="mb-1" key={index}>
                    <Card className="mb-1">
                      <CardBody>
                        <div>
                          <p className="text-center">
                            <IntlMessages id="alacarte.child" /> - {index + 1}
                          </p>
                        </div>

                        <hr />

                        <NameRoomAndMainCourseInfo
                          res={res}
                          request={request}
                          alacarteRequestTimeSlot={alacarteRequestTimeSlot}
                        />
                      </CardBody>
                    </Card>
                  </Colxx>
                );
              })}
            </Row>
          ) : (
            <IntlMessages id="alacarte.request_no_person_info" />
          )
        }
      </CardBody>
    </Card>
  );
};

const mapStateToProps = ({ alacarteApp, settings }) => {
  const { getSeatsAndSlots } = alacarteApp;

  return { settings, getSeatsAndSlots }
};

const mapActionsToProps = {
  getSeatsAndSlotsRestaurant
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(AlacarteServiceInfoSection)
);
